import { Modal, Table } from "antd";

const RegenerationHistory = (props) => {

    const {
        isModalOpen,
        setIsModalOpen,
        regenerateData,
        setRegeneratedData,
        onChange,
        pagination,
        setPagination,
    } = props;

    const columnsData = [
        { title: "Generated Date", key: "createdAt", dataIndex: "createdAt", render: (value) => {
        if (!value) return "";
        const date = new Date(value);
        return date.toLocaleString(); // e.g., "7/21/2025, 10:30:00 AM"
    } },
        { title: "File Name", key: "fileName", dataIndex: "fileName" },
        { title: "User Name", key: "userName", dataIndex: "userName" },
        // { title: "Status", key: "approvalStageName", dataIndex: "approvalStageName" },
        { title: "Total Amount", key: "totalDisbAmount", dataIndex: "totalDisbAmount" },
        { title: "Records in File", key: "recordsInFile", dataIndex: "recordsInFile" },
        { title: "Total Payout", key: "grossPayout", dataIndex: "grossPayout" },
        { title: "Payout on Hold", key: "payoutOnHold", dataIndex: "payoutOnHold" },
        { title: "Recovery Amount", key: "recoveryAmount", dataIndex: "recoveryAmount" },
        { title: "Retro Recovery", key: "retroAdj", dataIndex: "retroAdj" },
        { title: "Final Payout", key: "netPayout", dataIndex: "netPayout" },
      ];

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (

        <Modal title=" " centered width={1000} open={isModalOpen}  maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)',  }} footer={[]} onOk={handleOk} onCancel={handleCancel}>
            <Table dataSource={regenerateData}  onChange={onChange} style={{ maxHeight: "60vh", overflow: "auto" }} columns={columnsData} pagination={pagination} scroll={{ x: "max-content" }} />
        </Modal>

    )

}

export default RegenerationHistory;